import React, { useState, useEffect } from 'react';
import { Alert, Container, Dropdown } from 'react-bootstrap';
import { FaCloud, FaDatabase, FaFolderOpen, FaServer } from 'react-icons/fa';
import ManagedSourcesTable from './ManagedSourcesTable';
import { useParams } from 'react-router-dom';
import PageHeader from 'Utils/PageHeader';
import { CATEGORIES, isCategory } from '../LandscapeUtils';

const CATEGORY_HEADER = {
  rdbm: { label: 'Databases', Icon: FaDatabase },
  files: { label: 'File Storage', Icon: FaFolderOpen },
  servers: { label: 'Servers', Icon: FaServer },
};

const ManagedSources = (props) => {
  const [managedSources, setManagedSources] = useState();
  const { source } = useParams();

  useEffect(() => setManagedSources(props.managedSources), [props.managedSources]);

  const categoryHeader = isCategory(source) ? CATEGORY_HEADER[source] : null;
  const header = categoryHeader ? categoryHeader.label : 'Managed Sources';
  const Icon = categoryHeader ? categoryHeader.Icon : FaCloud;
  const tooltip = categoryHeader
    ? `All ${CATEGORIES[source].label.toLowerCase()} across AWS, Azure, and GCP.`
    : 'The following sources have been detected across your enabled cloud providers (AWS, Azure, GCP).';

  return (
    <Container fluid>
      <div>
        <PageHeader
          header={header}
          icon={Icon}
          tooltip={tooltip}
          actions={[
            <Dropdown.Item onClick={async () => props.refreshStatus()}>
              {props.fetchingData ? 'REFRESHING...' : 'REFRESH SOURCES'}
            </Dropdown.Item>
          ]}
        />

        { props.fetchingData ? (
          <Alert key={"refreshing-info"} variant={"info"}>
            Updating resource list...
          </Alert>
        ) : (null)}

        <ManagedSourcesTable
          managedSources={managedSources}
          showTabs={true}
          fetchingData={props.fetchingData}
          source={source}
          refreshStatus={ () => props.refreshStatus()}
          onActionStarted={props.onActionStarted}
        />
      </div>
    </Container>
  );
}
export default ManagedSources;
